import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
@Component({
  selector: 'app-viewbreedsmanagement',
  templateUrl: './viewbreedsmanagement.component.html',
  styleUrls: ['./viewbreedsmanagement.component.css']
})
export class ViewbreedsmanagementComponent implements OnInit {
  returnUrl= "/dashboard/breedsmanagement";
  getbreedsviewApi:any;
  getval:any;
  constructor(private router: Router,private commonService: CommonService) { }
  async ngOnInit(): Promise<void> {
    let breedsId = sessionStorage.getItem('breedsId');
    this.getbreedsviewApi= "/breeds/"+ breedsId;
    (await this.commonService.getApi(this.getbreedsviewApi)).subscribe(
      res => {
        console.log(res.data);
        $("#breedsviewName").text(res.data.name)
        $("#breedsviewId").text(res.data.breedID)
        $("#breedsfarmname").text(res.data.farm_name)
        $("#breedsSpeciesID").text(res.data.species_name)
        this.getval=res.data.status;
        if (this.getval==0) 
{
  $("#breedsStatus").text("InActive").addClass("red");
}
if (this.getval==1) {
 $("#breedsStatus").text("Active").addClass("green");
}    
      })
    }
    breedsmanagement(){
      this.router.navigate([this.returnUrl]);
    }
    backnavigate(){
      this.router.navigate([this.returnUrl]);
    }
  }
  
 

